// extracted by mini-css-extract-plugin
module.exports = {"page":"_15q71xihi71osPqENpQ3SY","link":"_2-0Eb4SJ2tcaYLQGQKerZ7","tabContent":"_3ULTD7w7XlypOiopF1_4mD","skeletonBox":"_2ZOEiVFg52fE0uVJjv4Cs8"};